import React, { useEffect, useState } from 'react';
import { Row, Col, Button, Spinner } from 'react-bootstrap';
import { CalendarHeart } from 'react-bootstrap-icons';
import ConfirmSchedule from './ConfirmSchedule';
import ScheduleModal from './ScheduleModal';
import { useDispatch, useSelector } from 'react-redux';
import LoaderView from 'happ-components/Loader/LoaderView';
import { getMedismartSchedulesAction } from 'happ-redux/happ-actions/medismartSchedule/medismartScheduleAction';
import { useNavigate } from 'react-router-dom';

const MedismartHomeWidget = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { 
        scheduleRequest,
        attentionDate,
        linkAttention,
        doctor,
        loading, 
        loadingRequest,
        specialist, 
        isSchedules, 
        loadingDelete,
        confirmDelete,    
        currentSchedule 
    } = useSelector(state => state.medismart);
    const { profile } = useSelector(state => state.auth);
    const [showModal, setShowModal] = useState(false); 
    const [modalText, setModalText] = useState('No hay horas disponibles');

    useEffect(() => {
      if (!loading && isSchedules === 'no-ok') {
        setShowModal(true);
      } else if (!loading && isSchedules === 'ok') {
        navigate('/agendar-hora-telemedicina');
      }
    }, [isSchedules, loading]);
    
    const getMedismartScheduleBydni = () => {
        if (profile) {
            dispatch(getMedismartSchedulesAction(profile.dni, navigate));
        }
    }
    return (
        <>
            {loadingDelete && confirmDelete === null ? (
                <Row className="mt-4 d-flex justify-content-center">
                    <div className="d-flex flex-column align-items-center text-center">
                        <Spinner animation="border" className="spinner-loading-days spinner-color" />
                        <small className="primary-color-text lh-1 title-message mt-2">Eliminando tu hora</small>
                    </div>
                </Row>
            ) : (
                currentSchedule !== undefined && currentSchedule === true ? (
                    <>
                        <ConfirmSchedule 
                            attentionDate={attentionDate}
                            linkAttention={linkAttention}
                            doctor={doctor}
                        />
                    </>
                ) : (
                    <>
                        {loadingRequest && (scheduleRequest === null || scheduleRequest === undefined)  ? (
                            <>
                                <div className='text-center mt-1 mb-1 loader-container'>
                                    <LoaderView
                                        animation="border"
                                        height={40}
                                    />
                                </div>
                            </>
                        ) : (
                            <>
                                {loading && !specialist ? (
                                    <Row className="mt-4 d-flex justify-content-center">
                                        <div className="d-flex flex-column align-items-center text-center">
                                            <Spinner animation="border" className="spinner-loading-days spinner-color" />
                                            <small className="primary-color-text lh-1 title-message mt-2">Buscando horas disponibles</small>
                                        </div>
                                    </Row>
                                ) : (
                                    <Row className="mt-4 d-flex flex-column align-items-center">
                                        <Col className="d-flex align-items-center justify-content-center gap-2">
                                            <p className="primary-color-text lh-1 title-message mb-0 text-center">
                                                Quiero una telemedicina
                                            </p>
                                            <CalendarHeart
                                                size={40}
                                                color='#044064' 
                                            />
                                        </Col>
                                        <Col className="mt-3 d-flex justify-content-center">
                                            <Button 
                                                className="btn-home-message"
                                                onClick={getMedismartScheduleBydni}
                                            >Buscar horas</Button>
                                        </Col>
                                    </Row>
                                )}
                            </>
                        )}
                    </>
                )
            )}
            {showModal ? (
                <ScheduleModal 
                    handleClose={() => setShowModal(false)}
                    show={showModal}
                    text={modalText}
                    target={'no-schedule'}
                />
            ) : null}
            {!loadingDelete && confirmDelete === false ? (
                <ScheduleModal 
                    handleClose={() => setShowModal(false)}
                    show={true}
                    text={'No se pudo eliminar la hora tomada'}
                    target={'no-schedule'}
                />
            ) : null}
            {!loadingDelete && confirmDelete === true ? (
                <ScheduleModal 
                    handleClose={() => setShowModal(false)}
                    show={true}
                    text={'Hora eliminada con éxito'}
                    target={'confirm-delete'}
                />
            ) : null}
        </>
    );
}
 
export default MedismartHomeWidget;